import { render, staticRenderFns } from "./bmContent.vue?vue&type=template&id=5e6c79df&scoped=true"
import script from "./bmContent.vue?vue&type=script&lang=ts"
export * from "./bmContent.vue?vue&type=script&lang=ts"
import style0 from "./bmContent.vue?vue&type=style&index=0&id=5e6c79df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c79df",
  null
  
)

export default component.exports